(function () {
  'use strict';

  // Weglot's switcher trigger shows the *current* language and opens a dropdown
  // listing the alternatives. With exactly one alternative (English <-> Arabic),
  // that extra dropdown step is pointless: relabel the trigger to show the
  // language you'd switch TO, and forward any click on the switcher straight to
  // Weglot's own (untouched) link for that alternative — Weglot's click handling
  // keys off that link's own id/attributes, so we let it fire natively instead of
  // trying to reconstruct navigation ourselves.
  function findSingleAlternate(switcher) {
    var links = switcher.querySelectorAll('.language-list a');
    return links.length === 1 ? links[0] : null;
  }

  function relabel(switcher, altLink) {
    if (switcher.dataset.directSwitchApplied) return;

    var triggerLink = switcher.querySelector('.active-language a');
    if (!triggerLink) return;

    switcher.dataset.directSwitchApplied = 'true';

    var altLabel = altLink.getAttribute('aria-label') || altLink.textContent;
    triggerLink.textContent = altLink.textContent;
    triggerLink.setAttribute('aria-label', altLabel);
    switcher.setAttribute('aria-label', 'Language Switcher: ' + altLabel);
  }

  function scanForSwitchers() {
    document.querySelectorAll('.weglot_switcher').forEach(function (switcher) {
      var altLink = findSingleAlternate(switcher);
      if (altLink) relabel(switcher, altLink);
    });
  }

  // The dropdown reveal is driven by CSS :hover, not a JS event we can
  // intercept — so hovering the trigger opens it regardless of what click/
  // mousedown handlers do. Force it closed with a stylesheet rule scoped to
  // switchers we've flagged as single-alternative.
  function injectHideDropdownStyle() {
    var style = document.createElement('style');
    style.textContent =
      '.weglot_switcher[data-direct-switch-applied="true"] .language-list { display: none !important; }';
    document.head.appendChild(style);
  }

  // Resolves the switcher + real alternate link an event should be redirected
  // to, or null if the event should be left alone (more than one alternative,
  // or it's already a click on the real link).
  function resolveInterceptTarget(event) {
    var switcher = event.target.closest('.weglot_switcher');
    if (!switcher) return null;

    var altLink = findSingleAlternate(switcher);
    if (!altLink) return null; // more than one alternative: let the real dropdown work
    if (event.target === altLink || altLink.contains(event.target)) return null; // already the real link

    return altLink;
  }

  // Listening on document in the capture phase guarantees these run before
  // Weglot's own listeners on the switcher itself, regardless of attach order —
  // a listener further down the tree can never fire before an ancestor's capture
  // listener. Weglot opens the dropdown on mousedown (before click even fires),
  // so mousedown has to be blocked too, or the dropdown flashes open for a
  // moment before the click handler below navigates away.
  document.addEventListener(
    'mousedown',
    function (event) {
      var altLink = resolveInterceptTarget(event);
      if (!altLink) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var altLink = resolveInterceptTarget(event);
      if (!altLink) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      altLink.click();
    },
    true
  );

  function init() {
    injectHideDropdownStyle();
    scanForSwitchers();
    new MutationObserver(scanForSwitchers).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
